// src/Homepage.jsx
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

// fallback images
import aboutImgDefault from "../assets/about-img.jpg";
import panelImgDefault from "../assets/panel.jpg";
import heroDefault from "../assets/hero.jpg";
import aboutImageNew from "../assets/About_1.jpg";

// ✅ Updated: LRQA as main client, others as subclients
import lrqaLogo from "../assets/clients/LRQA logo.jpg";
import imcLogo from "../assets/clients/IMC logo.jpg";
import danieliLogo from "../assets/clients/Danieli logo.png";

import "./Home.css";

const Homepage = ({
  hero = heroDefault || aboutImgDefault,
  aboutImg = aboutImgDefault,
  panelImg = panelImgDefault,
  logos = {}
}) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Set Browser Tab Title for Home Page
  useEffect(() => {
    document.title = "Home | Qnexa Services — Engineering & Inspection Specialists";
  }, []);


  // ✅ Updated: LRQA as main client, IMC & Danieli as subclients
  const mainClient = logos.main || [lrqaLogo];
  const subClients = logos.sub || [imcLogo, danieliLogo];

  const slides = [
    {
      id: 1,
      image: hero,
      title: "Welcome to Qnexa Services",
      description: "Professional engineering & inspection solutions across India"
    },
    {
      id: 2,
      image: aboutImg,
      title: "Reliable Inspection Services",
      description: "Quality-driven consultancy, inspection & project support"
    },
    {
      id: 3,
      image: panelImg,
      title: "Experienced Team",
      description: "Seasoned engineering entrepreneurs and certified inspectors"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [slides.length]);

  const nextSlide = () => setCurrentSlide((p) => (p + 1) % slides.length);
  const prevSlide = () =>
    setCurrentSlide((p) => (p - 1 + slides.length) % slides.length);
  const goToSlide = (index) => setCurrentSlide(index);

  return (
    <div className="home" id="home">
      {/* Background Animation */}
      <div className="animated-background">
        <div className="floating-shapes">
          <div className="floating-shape"></div>
          <div className="floating-shape"></div>
          <div className="floating-shape"></div>
          <div className="floating-shape"></div>
        </div>
      </div>

      {/* Hero Carousel Section */}
      <section className="section-container">
        <div className="hero" aria-label="Hero carousel">
          <div className="carousel">
            <div
              className="carousel-inner"
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {slides.map((slide) => (
                <div
                  key={slide.id}
                  className="carousel-slide"
                  role="group"
                  aria-roledescription="slide"
                >
                  <img src={slide.image} alt={slide.title} />
                  <div className="carousel-content">
                    <h1>{slide.title}</h1>
                    <p>{slide.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <button
              className="carousel-btn prev"
              onClick={prevSlide}
              aria-label="Previous slide"
            >
              ‹
            </button>
            <button
              className="carousel-btn next"
              onClick={nextSlide}
              aria-label="Next slide"
            >
              ›
            </button>

            <div
              className="carousel-indicators"
              role="tablist"
              aria-label="Slide indicators"
            >
              {slides.map((_, idx) => (
                <button
                  key={idx}
                  className={`indicator ${
                    idx === currentSlide ? "active" : ""
                  }`}
                  onClick={() => goToSlide(idx)}
                  aria-label={`Go to slide ${idx + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Section Divider */}
      <div className="section-divider">
        <div className="divider-wave"></div>
      </div>

      {/* About Section */}
      <section
        id="about"
        className="section-container about-section"
        aria-labelledby="about-heading"
      >
        <div className="container">
          <div className="about-content">
            <div className="about-text">
              <div className="eyebrow">About Us</div>
              <h2 id="about-heading" className="section-title">
                Qnexa Services
              </h2>

              <p className="paragraph">
                Welcome to Qnexa Services Established in 2015, Qnexa Services is
                a professional Engineering and Inspection Solutions provider led
                by a team of seasoned engineering entrepreneurs. We serve a wide
                range of sectors…
              </p>

              <p className="paragraph">
                We deliver reliable, cost-effective, and high-quality
                consultancy, project supervision, and inspection services…
              </p>

              <Link className="readmore-btn" to="/about">
                Read More
              </Link>
            </div>

            <div className="about-image" aria-hidden="true">
              <img
                src={aboutImageNew}
                alt="Qnexa team / inspection"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Section Divider */}
      <div className="section-divider">
        <div className="divider-wave reverse"></div>
      </div>

      {/* Vision, Objective, Core Strengths */}
      <section
        className="section-container panel-section stylish-panel"
        aria-labelledby="vision-heading"
      >
        <div className="container">
          <div className="panel-content stylish-grid">
            <div className="panel-left">
              <div className="eyebrow">Guiding Principle</div>
              <h2 id="vision-heading" className="section-title">
                Vision
              </h2>

              <p className="vision-text">
                To be recognized as one of the most trusted engineering
                consultants…
              </p>

              <div className="objective-block">
                <div className="eyebrow">Objective</div>
                <p className="paragraph">
                  To support businesses in achieving operational excellence by
                  enhancing…
                </p>
              </div>

              <div className="cta-row">
                <Link to="/contact" className="cta-primary">
                  Request Proposal
                </Link>

                <Link
                  to="/services"
                  style={{
                    background: "black",
                    color: "yellow",
                    padding: "10px 16px",
                    borderRadius: "20px",
                    fontWeight: "700",
                    textDecoration: "none",
                    display: "inline-block",
                    transition: "0.3s"
                  }}
                  onMouseOver={(e) => {
                    e.target.style.background = "yellow";
                    e.target.style.color = "black";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.background = "black";
                    e.target.style.color = "yellow";
                  }}
                >
                  View Services
                </Link>
              </div>
            </div>

            <div className="panel-right">
              <div className="strengths-header">
                <div
                  className="eyebrow"
                  style={{
                    color: "black",
                    fontWeight: "700",
                    fontSize: "1rem"
                  }}
                >
                  Our Core Strengths
                </div>

                <h3 className="strengths-sub">
                  Capabilities that make us dependable
                </h3>
              </div>

              <div className="strengths-grid" role="list">
                {[
                  "Strong domain expertise across multiple industries.",
                  "Qualified and certified inspection professionals.",
                  "Pan-India availability of Quality Inspectors.",
                  "Timely submissions with detailed reporting.",
                  "Cost efficiency, quality assurance, safety compliance.",
                  "NCRs analyzed with root cause identification.",
                  "Customer-centric long-term relationship focus."
                ].map((text, i) => (
                  <div className="strength-card" key={i} role="listitem">
                    <div className="strength-icon">
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M20 6L9 17L4 12"
                          stroke="#fff"
                          strokeWidth="2.2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="strength-text">{text}</div>
                  </div>
                ))}
              </div>

              <div className="panel-note">
                <small>
                  <strong>Note:</strong> We analyze NCRs thoroughly and implement
                  corrective actions.
                </small>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section Divider */}
      <div className="section-divider">
        <div className="divider-wave"></div>
      </div>

      {/* Services Section */}
      <section
        id="services"
        className="section-container services-section"
        aria-labelledby="services-heading"
      >
        <div className="container">
          <div className="services-content">
            <div className="section-header">
              <div className="eyebrow" data-aos="fade-up">
                Service Portfolio
              </div>
              <h2
                id="services-heading"
                className="section-title"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                Qnexa Services - What We Offer
              </h2>
              <div
                className="title-underline"
                data-aos="fade-up"
                data-aos-delay="200"
              ></div>
            </div>

            <div
              className="intro-paragraph"
              data-aos="fade-up"
              data-aos-delay="150"
            >
              <strong>Qnexa Services</strong> offers multi-disciplinary
              engineering, inspection and consultancy services including:
            </div>

            {/* Service Cards */}
            <div
              className="service-categories"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <div
                className="service-category-card"
                data-aos="zoom-in"
                data-aos-delay="250"
              >
                <div className="category-icon">⚙️</div>
                <div className="category-content">
                  <h3>Static Equipment</h3>
                  <p>
                    Pressure Vessels, Heat Exchangers, Structures, Pipes,
                    Fittings…
                  </p>
                </div>
              </div>

              <div
                className="service-category-card"
                data-aos="zoom-in"
                data-aos-delay="300"
              >
                <div className="category-icon">🔄</div>
                <div className="category-content">
                  <h3>Rotary Equipment</h3>
                  <p>Pumps, Compressors, Valves, Blowers.</p>
                </div>
              </div>

              <div
                className="service-category-card"
                data-aos="zoom-in"
                data-aos-delay="350"
              >
                <div className="category-icon">⚡</div>
                <div className="category-content">
                  <h3>Electrical Equipment</h3>
                  <p>
                    Cables, Transformers, Panels, Switchgears, Circuit Breakers…
                  </p>
                </div>
              </div>

              <div
                className="service-category-card"
                data-aos="zoom-in"
                data-aos-delay="400"
              >
                <div className="category-icon">🔍</div>
                <div className="category-content">
                  <h3>Inspections</h3>
                  <p>
                    Mechanical, E&I, and Civil Inspections across project sites.
                  </p>
                </div>
              </div>
            </div>

            {/* Additional Services */}
            <div
              className="additional-services"
              data-aos="fade-up"
              data-aos-delay="450"
            >
              <div className="services-eyebrow">Additional Services</div>

              <div className="animated-services-grid">
                {[
                  "Verification, Evaluation, Expediting & Audits",
                  "Project Management & Execution Support",
                  "Tendering & Bid Management",
                  "Strategy & Business Development",
                  "Sourcing & Procurement Support",
                  "Energy Efficiency Audits & Consultancy",
                  "Safety Audits as per PNGRB and statutory guidelines"
                ].map((item, idx) => (
                  <div
                    key={idx}
                    className="service-item"
                    data-aos="fade-right"
                    data-aos-delay={500 + idx * 50}
                  >
                    <span className="service-bullet">✓</span>
                    {item}
                  </div>
                ))}
              </div>
            </div>

            {/* Conclusion */}
            <div
              className="conclusion-section"
              data-aos="fade-up"
              data-aos-delay="900"
            >
              <h3 className="conclusion-title">Conclusion</h3>

              <div className="conclusion-content">
                <p className="conclusion-paragraph">
                  At Qnexa Services, we are committed to delivering
                  cost-effective, timely, and high-quality services…
                </p>

                <div
                  className="highlight-message"
                  data-aos="fade-up"
                  data-aos-delay="950"
                >
                  <span className="sparkle">✨</span>
                  <span>
                    We look forward to your valuable enquiries and long-term
                    partnership.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section Divider */}
      <div className="section-divider">
        <div className="divider-wave reverse"></div>
      </div>

      {/* CLIENTS SECTION - UPDATED */}
      <section className="section-container clients-section">
        <div className="container">
          <div className="clients-content">
            <div className="eyebrow">Our Trusted Partners</div>
            <h2 className="section-title">OUR CLIENTS</h2>
            
            {/* Main Client - LRQA */}
            <div className="main-client-section">
              <div className="main-client-label">Primary Client</div>
              <div className="main-client-display">
                <img
                  src={mainClient[0]}
                  alt="LRQA - Main Client"
                  className="main-client-logo"
                />
                <div className="main-client-info">
                  <h3>LRQA</h3>
                  <p>Lloyd's Register Quality Assurance</p>
                </div>
              </div>
            </div>

            {/* Sub Clients */}
            <div className="sub-clients-section">
              <div className="sub-clients-label">Associate Clients</div>
              <div className="sub-clients-grid">
                {subClients.map((logo, idx) => (
                  <div key={idx} className="sub-client-card">
                    <img
                      src={logo}
                      alt={`Sub Client ${idx + 1}`}
                      className="sub-client-logo"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section Divider */}
      <div className="section-divider">
        <div className="divider-wave"></div>
      </div>
    </div>
  );
};

export default Homepage;